
































































































import {
    Component,
    Vue
} from "vue-property-decorator";
import {
    request
} from '@/utils/request'
import {
    api_get,
    api_post
} from "../api/isso";
import TopicBlock from '@/components/Topic/TopicBlock.vue'
import BackToTop from '@/components/BackToTop.vue'
import utils from '@/utils/utils'
@Component({
    components: {
        TopicBlock,
        BackToTop
    }
})
export default class Forums extends Vue {
    topics = []
    forum_id = 11
    from_id = -1
    loading = false
    mounted() {
        this.forum_id = parseInt(this.$route.params.id)
        this.do_load_topic()
    }

    destroyed() {
    }

    do_load_topic() {
        let that = this
        this.loading = true
        let update_time=''
        if (this.topics.length>0){
            update_time = this.topics[this.topics.length-1][0].update_time
        }
        api_post('/api/isso/topic/list', {
            id: this.forum_id,
            update_time: update_time
        }).then(res => {
            if (that.topics.length==0)
                that.topics = res
            else{
                for(let topics of  res){
                    let in_ = false
                    for(let o_topics of that.topics){
                        if (topics[0].topic_id === o_topics[0].topic_id){
                            in_ = true
                        }
                    }
                    if (! in_){
                        that.topics.push(topics)
                    }
                }
            }
        }).catch(res => {
            console.error(res)
        }).finally(() => {
            that.$nextTick(() => {
                that.loading = false
            })
        })
    }
    load() {}
    get is_show_load_more(){
        return !this.loading && this.topics.length>0
    }
}
